import {observer} from "mobx-react-lite";
import {AutoComplete} from "primereact/autocomplete";
import {useEffect, useState} from "react";
import clubStore from "../../storage/ClubStore";
import appStore from "../../storage/AppStore";
import "./../../common/autocomplete.css";

const MemberSearch = ({role_id="MMBR", company_user_id=null, company_id=null, onSelect, onClear, placeholder}) => {
  const [searchText, setSearchText] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [suggestions, setSuggestions] = useState([]);

  const search = async ({query}) => {
    const title = (query || "").trim();
    if (title.length < 2) {
      setSuggestions([]);
      return;
    }
    const ret = await clubStore.searchMembersForFilter({title, role_id, company_id});
    setSuggestions(ret || []);
  };

  useEffect(() => {
    let active = true;
    const load = async () => {
      if (!company_user_id) {
        setSelectedUser(null);
        setSearchText("");
        return;
      }
      const ret = await clubStore.searchMembersForFilter({company_user_id, company_id});
      if (!active) return;
      const user = ret?.[0] || null;
      setSelectedUser(user);
      setSearchText(user?.title || "");
    };
    load();
    return () => { active = false; };
  }, [company_user_id, company_id]);

  const handleChange = (e) => {
    if (typeof e.value === "string") {
      setSearchText(e.value);
      if (selectedUser) {
        setSelectedUser(null);
        onSelect?.(null);
      }
    }
  };

  const handleSelect = (e) => {
    setSelectedUser(e.value);
    setSearchText(e.value.title || "");
    onSelect?.(e.value.company_user_id);
  };

  const clear = () => {
    setSelectedUser(null);
    setSearchText("");
    setSuggestions([]);
    onSelect?.(null);
    onClear?.();
  };

  const itemTemplate = (user) => (
    <div className="member-search-item">
      <div className="member-search-item-icon"><i className="pi pi-user"/></div>
      <div className="member-search-item-title">{user.title}</div>
    </div>
  );

  return (
    <div className="member-search">
      <i className="pi pi-user member-search-icon"/>
      <AutoComplete
        className="member-search-input"
        inputClassName="member-search-control"
        panelClassName="member-search-panel"
        field="title"
        value={selectedUser || searchText}
        suggestions={suggestions}
        completeMethod={search}
        itemTemplate={itemTemplate}
        placeholder={placeholder || appStore.tr.member || appStore.tr.title}
        emptyMessage={appStore.tr.not_found}
        delay={250}
        minLength={2}
        forceSelection={false}
        onChange={handleChange}
        onSelect={handleSelect}
      />
      {(searchText || selectedUser) && (
        <button type="button" className="member-search-clear" onClick={clear} aria-label="Clear">
          <i className="pi pi-times"/>
        </button>
      )}
    </div>
  );
};

export default observer(MemberSearch);